var drawer = function () {
    if (!Element.prototype.closest) {
        if (!Element.prototype.matches) {
            Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        }
        Element.prototype.closest = function (s) {
            var el = this;
            var ancestor = this;
            if (!document.documentElement.contains(el)) return null;
            do {
                if (ancestor.matches(s)) return ancestor;
                ancestor = ancestor.parentElement;
            } while (ancestor !== null);
            return null;
        };
    }
    var settings = {
        speedOpen: 50,
        speedClose: 350,
        activeClass: 'is-active',
        visibleClass: 'is-visible',
        selectorTarget: '[data-drawer-target]',
        selectorTrigger: '[data-drawer-trigger]',
        selectorClose: '[data-drawer-close]',

    };


    var toggleccessibility = function (event) {
        if (event.getAttribute('aria-expanded') === 'true') {
            event.setAttribute('aria-expanded', false);
        } else {
            event.setAttribute('aria-expanded', true);
        }
    };


    var openDrawer = async function (trigger) {
        var target = document.getElementById(trigger.getAttribute('aria-controls'));
        target.classList.add(settings.activeClass);
        document.documentElement.style.overflow = 'hidden';
        toggleccessibility(trigger);

        setTimeout(function () {
            target.classList.add(settings.visibleClass);
            drawerCart.populateDrawer()
        }, settings.speedOpen);
    };

    var closeDrawer = function (event) {
        var closestParent = event.closest(settings.selectorTarget),
            childrenTrigger = document.querySelector('[aria-controls="' + closestParent.id + '"');
        closestParent.classList.remove(settings.visibleClass);
        document.documentElement.style.overflow = '';
        toggleccessibility(childrenTrigger);
        setTimeout(function () {
            closestParent.classList.remove(settings.activeClass);
        }, settings.speedClose);
    };
    var clickHandler = function (event) {
        var toggle = event.target,
            open = toggle.closest(settings.selectorTrigger),
            close = toggle.closest(settings.selectorClose);


        if (open) { openDrawer(open); }
        if (close) { closeDrawer(close); }
        if (open || close) { event.preventDefault(); }
    };


    var keydownHandler = function (event) {
        if (event.key === 'Escape' || event.keyCode === 27) {
            var drawers = document.querySelectorAll(settings.selectorTarget),
                i;
            for (i = 0; i < drawers.length; ++i) {
                if (drawers[i].classList.contains(settings.activeClass)) {
                    closeDrawer(drawers[i]);
                }
            }
        }
    };

    document.addEventListener('click', clickHandler, false);
    document.addEventListener('keydown', keydownHandler, false);
};

drawer();


const drawerCart = {
    openDrawer: () => {
        document.querySelector("[data-drawer-trigger]").click();
    },
    populateDrawer: async function () {
        const sections = await globalFunctions.fetchSection(["drawer-wrapper", "cart-icon-bubble"])
        globalFunctions.renderSections(sections["drawer-wrapper"], document.querySelector('#drawer__wrapper'))
        globalFunctions.renderSections(sections["cart-icon-bubble"], document.querySelector('#cart-icon-bubble'))
        this.applyQtyListeners()
        countDown();
    },
    applyQtyListeners: () => {
        const qty_buttons = document.querySelectorAll(".drawer__line_item_qty button")
        qty_buttons.forEach(function (button) {
            if (button.classList.contains("minus")) {
                button.addEventListener("click", async function (e) {
                    const quantity = parseInt(button.nextElementSibling.innerText) - 1
                    const line = parseInt(button.closest(".drawer__line_item").getAttribute("data-line-item-index"))
                    button.innerHTML = `<div class="loading-overlay__spinner">
                        <svg  aria-hidden="true"  focusable="false"  class="w-6 h-5 animate-rotator"  viewBox="0 0 66 66"  xmlns="http://www.w3.org/2000/svg">
                            <circle class="animate-dash path stroke-gray-500" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>`
                    await drawerCart.updateQty(line, quantity)
                    return console.log("MINUS", e, quantity)
                })
            }
            if (button.classList.contains("plus")) {
                button.addEventListener("click", async function (e) {
                    const quantity = Number(parseInt(button.previousElementSibling.innerText) + 1)
                    const line = parseInt(button.closest(".drawer__line_item").getAttribute("data-line-item-index"))
                    button.innerHTML = `<div class="loading-overlay__spinner">
                        <svg  aria-hidden="true"  focusable="false"  class="w-6 h-5 animate-rotator"  viewBox="0 0 66 66"  xmlns="http://www.w3.org/2000/svg">
                            <circle class="animate-dash path stroke-gray-500" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                    </div>`
                    await drawerCart.updateQty(line, quantity)
                    return console.log("PLUS", e, quantity)
                })
            }
        })
        const rmv_buttons = document.querySelectorAll("button.drawer__line_item-remove")
        rmv_buttons.forEach(function (button) {
            button.addEventListener("click", async function (e) {
                const quantity = 0
                const line = parseInt(button.closest(".drawer__line_item").getAttribute("data-line-item-index"))
                button.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="12" viewBox="0 0 512 512"><!--!Font Awesome Free v7.2.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2026 Fonticons, Inc.--><path d="M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8-79.3 23.6-137.1 97.1-137.1 184.1 0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256 512 397.4 397.4 512 256 512S0 397.4 0 256c0-116 77.1-213.9 182.9-245.4 16.9-5 34.8 4.6 39.8 21.5z"/></svg>`
                await drawerCart.updateQty(line, quantity)
                return console.log("REMOVE", e, quantity)
            })
        })
    },
    updateQty: async (line, quantity) => {
        const data = { line, quantity, sections: ["cart-icon-bubble"] }
        const response = await cartHandler.changeCart(data)
        drawerCart.populateDrawer()
    }
}